import React from 'react';
import {Flex, Text, Button, Image, Box} from '@spothero/ui';
import PropTypes from 'prop-types';
import FormatUtils from 'utils/format';
import ChangePhoneModal from '../change-phone-modal';
import ReservationUtils from 'utils/reservation-utils';
import UserUtils from 'utils/user-utils';
import {
    PROPTYPE_RESERVATION,
    PROPTYPE_RESERVATION_PAYMENT_STATUS,
} from '@/proptypes/reservation-prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {CHANGE_PHONE} from 'store/parking-pass/parking-pass-reducer';
import {toggleModal} from 'store/parking-pass/parking-pass-actions';

const PhoneDetails = ({
    reservation,
    paymentStatus,
    activeStatus,
    onTrackedClick,
}) => {
    const dispatch = useDispatch();
    const {id: userId, status: userStatus} = useSelector(({user}) => user.data);
    const isOpen = useSelector(state => state.parkingPass.modals[CHANGE_PHONE]);
    const handleToggleModal = () => {
        dispatch(toggleModal({modal: CHANGE_PHONE}));
    };
    const canEdit =
        paymentStatus !== ReservationUtils.PAYMENT_STATUSES.REFUND &&
        activeStatus !== ReservationUtils.ACTIVE_STATUS.ENDED;
    const handleEditClick = () => {
        handleToggleModal();

        onTrackedClick({
            clickTarget: 'Change Phone Number',
            isReservationChange: true,
        });
    };

    if (
        !reservation.facility.phoneNumberRequired &&
        reservation.reservationType !==
            ReservationUtils.RESERVATION_TYPES.MONTHLY
    ) {
        return null;
    }

    const hidePhoneNumber =
        !userId ||
        userStatus === UserUtils.AUTH_STATE.GUEST ||
        userId !== reservation.renterId;
    let formattedPhoneNumber = null;

    if (
        reservation.phoneNumber &&
        typeof reservation.phoneNumber === 'string' &&
        reservation.phoneNumber !== ''
    ) {
        formattedPhoneNumber = hidePhoneNumber
            ? `(XXX) XXX-${reservation.phoneNumber.slice(-4)}`
            : FormatUtils.phone(reservation.phoneNumber);
    }

    return (
        <>
            <Flex
                borderBottomWidth="1px"
                borderColor="gray.100"
                padding={4}
                justifyContent="space-between"
                alignItems="center"
            >
                <Flex minWidth={0}>
                    <Image
                        src="/img/parking-pass/phone.svg"
                        width={6}
                        height="auto"
                        marginRight={2.5}
                        color="gray.dark"
                    />
                    <Text lineHeight={1.4}>
                        {formattedPhoneNumber ? (
                            formattedPhoneNumber
                        ) : (
                            <Box as="span" color="error">
                                Missing Phone Number
                            </Box>
                        )}
                    </Text>
                </Flex>
                {canEdit && (
                    <Button
                        sx={{
                            '@media print': {
                                display: 'none',
                            },
                        }}
                        onClick={handleEditClick}
                        variant="tertiary"
                        whiteSpace="nowrap"
                        marginLeft={2}
                        fontWeight="semibold"
                        fontFamily="body"
                    >
                        Change
                    </Button>
                )}
            </Flex>
            <ChangePhoneModal
                reservation={reservation}
                isOpen={isOpen}
                onClose={handleToggleModal}
                hidePhoneNumber={hidePhoneNumber}
                activeStatus={activeStatus}
            />
        </>
    );
};

PhoneDetails.propTypes = {
    reservation: PROPTYPE_RESERVATION.isRequired,
    activeStatus: PropTypes.oneOf(
        Object.values(ReservationUtils.ACTIVE_STATUS)
    ),
    paymentStatus: PROPTYPE_RESERVATION_PAYMENT_STATUS,
    onTrackedClick: PropTypes.func.isRequired,
};

export default PhoneDetails;
